import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.q5g().v51() : headers;
  return DelegatedCall().m5i(_this__u8e3s4.l5g_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, originCall, responseContent, responseHeaders) {
        return new.target.m5i(client, originCall, responseContent, responseHeaders);
      }
      static m5i(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.q5g().v51() : responseHeaders;
        var $this = this.n5i(client);
        $this.n5g_1 = new (DelegatedRequest())($this, originCall.o5i());
        $this.o5g_1 = new (DelegatedResponse())($this, originCall.q5g(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.t5i_1 = origin;
        this.u5i_1 = call;
      }
      v5i() {
        return this.u5i_1;
      }
      bw() {
        return this.t5i_1.bw();
      }
      w5i() {
        return this.t5i_1.w5i();
      }
      x5i() {
        return this.t5i_1.x5i();
      }
      p5i() {
        return this.t5i_1.p5i();
      }
      z2n() {
        return this.t5i_1.z2n();
      }
      v51() {
        return this.t5i_1.v51();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.v51() : headers;
        super();
        this.y5i_1 = call;
        this.z5i_1 = origin;
        this.a5j_1 = content;
        this.b5j_1 = headers;
        this.c5j_1 = this.z5i_1.bw();
      }
      v5i() {
        return this.y5i_1;
      }
      v51() {
        return this.b5j_1;
      }
      d5j() {
        return this.a5j_1(this.z5i_1);
      }
      bw() {
        return this.c5j_1;
      }
      e5j() {
        return this.z5i_1.e5j();
      }
      f5j() {
        return this.z5i_1.f5j();
      }
      g5j() {
        return this.z5i_1.g5j();
      }
      h5j() {
        return this.z5i_1.h5j();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
